import { render, staticRenderFns } from "./_Form.vue?vue&type=template&id=b6b96fac&scoped=true&"
import script from "./_Form.vue?vue&type=script&lang=js&"
export * from "./_Form.vue?vue&type=script&lang=js&"
import style0 from "./_Form.vue?vue&type=style&index=0&id=b6b96fac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b96fac",
  null
  
)

export default component.exports